import { Row, Col } from "react-bootstrap";
import styles from "./HeadingSection.module.css";

interface PropsType {
    subHeading: string | null,
    mainHeading: string | null,
    content: string[] | null
}
export default function HeadingSection(props: PropsType) {
    return (
        <Row>
            <Col md="12" className={`${styles.sectionContainer}`}>
                <Row>
                    <Col md="12" className={`${styles.subHeading}`}>
                        <span>{props.subHeading}</span>
                    </Col>
                    {props.mainHeading ?
                        <Col md="12" className={`${styles.mainHeading}`}>
                            <span>{props.mainHeading}</span>
                        </Col>
                        : null}
                    <Col md={{ span: "10", offset: "1" }} sm="12" className={`${styles.content}`}>
                        {props.content?.map(cont => {
                            return (
                                <p>{cont}</p>
                            )
                        })}
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}